<template>
  <div class="statistics-corners-goals">
    <StatisticsCornersGoalsMobile v-if="isMobile" :data-by-period="dataByPeriod" @click="onClick" />
    <StatisticsCornersGoalsDesktop
      v-else
      :data-by-period="dataByPeriod"
      :is-corners="this.type === 'corners'"
      @click="onClick"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'StatisticsCornersGoals',
  components: {
    StatisticsCornersGoalsDesktop: () =>
      import('@/components/Sections/GolTipster-v2/General/StatisticsCornersGoalsDesktop'),
    StatisticsCornersGoalsMobile: () =>
      import('@/components/Sections/GolTipster-v2/General/StatisticsCornersGoalsMobile'),
  },
  props: {
    type: {
      type: String,
      default: 'corners', // 'corners' or 'goals'
    },
  },
  computed: {
    ...mapState(['windowWidth']),
    ...mapState('betsGeneral', ['selectedGame']),
    ...mapState('loginGeneral', ['tournamentsForMediaPlayer']),
    ...mapGetters('betsGeneral', ['cornersDataByPeriod', 'goalsDataByPeriod']),
    ...mapGetters('loginGeneral', ['getUser', 'getSeasonSelected']),
    isMobile() {
      return this.windowWidth < 930;
    },
    dataByPeriod() {
      return this.type === 'corners' ? this.cornersDataByPeriod : this.goalsDataByPeriod;
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    onClick({ booleanIsHomeTeam, arrayMatchSections }) {
      const arrayGoalCategories = this.type === 'corners' ? [31, 32] : [12, 55, '35_r', '54_r'];
      const jsonConfig = {
        seasonId: this.getSeasonSelected,
        tournaments: this.tournamentsForMediaPlayer,
        categoryIds: arrayGoalCategories,
        categorySingleName: this.type === 'corners' ? 'Tiro de esquina' : 'Gol',
        mainSectionType: 1,
        playListType: 3,
        isRivalSubject: false,
        avoidCategorySingleName: false,
        playerIds: [],
        teamId: booleanIsHomeTeam ? this.selectedGame.homeTeam.team_id : this.selectedGame.awayTeam.team_id,
        advancedFilter: {
          mainCategoryId: {},
          playingAs: [1, 2],
          timeSections: arrayMatchSections,
          fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        },
      };

      this.setModalInitialState(jsonConfig);
      this.setIsModalOpen(true);
    },
  },
};
</script>

<style scoped lang="scss">
.statistics-corners-goals {
  width: 100%;
}
</style>
